import React from 'react';
import styled from 'styled-components';

import { Spinner } from 'ui/components/styled';
import { useScroller } from 'hooks';

export const LoadingOverlay = ({ scrollable, ...rest }) => {
  const { top } = useScroller(scrollable);

  const handleClick = (event) => {
    event.stopPropagation();
  };

  return (
    <Container onClick={handleClick} {...rest} top={top}>
      <Overlay />
      <Spinner centered />
    </Container>
  );
};

const Container = styled.div.attrs(({ top }) => ({
  style: { top }, // fixes frequently changed styles warning
}))`
  position: ${({ position = 'absolute' }) => position};
  z-index: ${({ zIndex = 1010 }) => zIndex};
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  min-height: 2em;
  overflow: hidden;
`;

const Overlay = styled.div`
  width: 100%;
  height: 100%;
  opacity: 0.5;
  filter: alpha(opacity=50);
  background-color: #fff;
`;
